/* Shared resource library interactions */
if (!window.NetumSupportLibrariesLoaded) {
window.NetumSupportLibrariesLoaded = true;
(() => {
  const initializeResourceLibrary = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const search = root.querySelector('[data-resource-search]');
    const clear = root.querySelector('[data-resource-clear]');
    const product = root.querySelector('[data-resource-product]');
    const type = root.querySelector('[data-resource-type]');
    const platform = root.querySelector('[data-resource-platform]');
    const rows = [...root.querySelectorAll('[data-resource-row]')];
    const count = root.querySelector('[data-resource-count]');
    const noResults = root.querySelector('[data-resource-no-results]');
    const pagination = root.querySelector('[data-resource-pagination]');
    const pages = root.querySelector('[data-resource-pages]');
    const previous = root.querySelector('[data-resource-previous]');
    const next = root.querySelector('[data-resource-next]');
    const itemsPerPage = Math.max(1, Number(root.dataset.itemsPerPage) || 9);
    const initialModel = new URLSearchParams(window.location.search).get('model');
    if (search && initialModel && search.value.trim() === '') search.value = initialModel;
    const facets = [
      { name: 'product', select: product, matches: (row, value) => row.dataset.product === value },
      { name: 'type', select: type, matches: (row, value) => row.dataset.type === value },
      { name: 'platform', select: platform, matches: (row, value) => (row.dataset.platform || '').includes(value) },
    ].filter((facet) => facet.select);
    let currentPage = 1;

    const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');

    const matchesRow = (row, excludedFacet = '') => {
      const query = normalize(search?.value);
      if (query && !normalize(row.dataset.search).includes(query)) return false;
      return facets.every((facet) => {
        if (facet.name === excludedFacet || facet.select.value === 'all') return true;
        return facet.matches(row, facet.select.value);
      });
    };

    const optionHasResults = (facet, value) => rows.some((row) => {
      if (!matchesRow(row, facet.name)) return false;
      return facet.matches(row, value);
    });

    const updateFacetOptions = (changedFacet = '') => {
      let selectionChanged = false;

      facets.forEach((facet) => {
        if (facet.name === changedFacet || facet.select.value === 'all') return;
        if (!optionHasResults(facet, facet.select.value)) {
          facet.select.value = 'all';
          selectionChanged = true;
        }
      });

      if (selectionChanged) updateFacetOptions(changedFacet);

      facets.forEach((facet) => {
        let availableOptions = 0;
        [...facet.select.options].forEach((option) => {
          if (option.value === 'all') {
            option.hidden = false;
            option.disabled = false;
            return;
          }
          const available = optionHasResults(facet, option.value);
          option.hidden = !available;
          option.disabled = !available;
          if (available) availableOptions += 1;
        });
        facet.select.disabled = availableOptions === 0;
        facet.select.setAttribute('aria-disabled', String(availableOptions === 0));
      });
    };

    const renderRows = (changedFacet = '') => {
      updateFacetOptions(changedFacet);
      const matches = rows.filter((row) => matchesRow(row));

      const totalPages = Math.ceil(matches.length / itemsPerPage);
      currentPage = Math.min(Math.max(currentPage, 1), Math.max(totalPages, 1));
      const visibleRows = new Set(matches.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage));
      rows.forEach((row) => { row.hidden = !visibleRows.has(row); });

      if (count) count.textContent = String(matches.length);
      if (noResults) noResults.hidden = matches.length !== 0;
      if (clear) clear.hidden = !search?.value;

      if (pagination && pages && previous && next) {
        pagination.hidden = totalPages <= 1;
        previous.disabled = currentPage <= 1;
        next.disabled = currentPage >= totalPages;
        pages.replaceChildren();
        for (let page = 1; page <= totalPages; page += 1) {
          const button = document.createElement('button');
          button.className = 'support-resource-library__page-button';
          button.type = 'button';
          button.textContent = String(page);
          button.dataset.resourcePage = String(page);
          button.setAttribute('aria-label', `Page ${page}`);
          if (page === currentPage) button.setAttribute('aria-current', 'page');
          pages.appendChild(button);
        }
      }
    };

    const resetAndRender = (changedFacet = '') => {
      currentPage = 1;
      renderRows(changedFacet);
    };

    search?.addEventListener('input', () => resetAndRender());
    product?.addEventListener('change', () => resetAndRender('product'));
    type?.addEventListener('change', () => resetAndRender('type'));
    platform?.addEventListener('change', () => resetAndRender('platform'));
    clear?.addEventListener('click', () => {
      search.value = '';
      search.focus();
      resetAndRender();
    });
    pagination?.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button.matches('[data-resource-previous]')) currentPage -= 1;
      if (button.matches('[data-resource-next]')) currentPage += 1;
      if (button.dataset.resourcePage) currentPage = Number(button.dataset.resourcePage);
      renderRows();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.querySelector('[data-resource-list]')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
    renderRows();
  };

  document.querySelectorAll('[data-support-resource-library]').forEach(initializeResourceLibrary);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.('[data-support-resource-library]')
      ? event.target
      : event.target.querySelector?.('[data-support-resource-library]');
    initializeResourceLibrary(root);
  });
})();


(() => {
    const initialize = (section) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const seriesFilter = section.querySelector('[data-series-filter]');
      const searchInput = section.querySelector('[data-manual-search]');
      const clearButton = section.querySelector('[data-manual-clear]');
      const noResults = section.querySelector('[data-manual-no-results]');
      const groups = Array.from(section.querySelectorAll('[data-series]'));

      const normalizeModel = (value) => String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');

      const updateCount = (group, visibleCount, searching) => {
        const countElement = group.querySelector('[data-series-count]');
        if (!countElement) return;

        const totalCount = Number(countElement.dataset.totalCount || 0);
        const count = searching ? visibleCount : totalCount;
        const singular = countElement.dataset.itemSingular || 'model';
        const plural = countElement.dataset.itemPlural || 'models';
        countElement.textContent = `${count} ${count === 1 ? singular : plural}`;
      };

      const applyFilters = () => {
        const selected = seriesFilter?.value || 'all';
        const rawQuery = searchInput?.value.trim() || '';
        const normalizedQuery = normalizeModel(rawQuery);
        const searching = rawQuery !== '';
        let totalMatches = 0;

        groups.forEach((group) => {
          const seriesMatches = selected === 'all' || group.dataset.series === selected;
          const rows = Array.from(group.querySelectorAll('[data-manual-row]'));
          let visibleCount = 0;

          rows.forEach((row) => {
            const model = normalizeModel(row.dataset.model);
            const modelMatches = !searching || (normalizedQuery !== '' && model.includes(normalizedQuery));
            const rowMatches = seriesMatches && modelMatches;
            row.hidden = !rowMatches;
            if (rowMatches) visibleCount += 1;
          });

          totalMatches += visibleCount;
          group.hidden = !seriesMatches || visibleCount === 0;
          updateCount(group, visibleCount, searching);

          if (!group.hidden && (searching || selected !== 'all')) {
            group.open = true;
          }
        });

        if (clearButton) clearButton.hidden = !searching;
        if (noResults) noResults.hidden = totalMatches > 0;
      };

      seriesFilter?.addEventListener('change', applyFilters);
      searchInput?.addEventListener('input', applyFilters);

      clearButton?.addEventListener('click', () => {
        if (!searchInput) return;
        searchInput.value = '';
        applyFilters();
        searchInput.focus();
      });

      applyFilters();

      section.querySelectorAll('[data-manual-row]').forEach((row) => {
        const languageButtons = Array.from(row.querySelectorAll('[data-language]:not(:disabled)'));
        const download = row.querySelector('[data-manual-download]');
        if (!download) return;

        languageButtons.forEach((languageButton) => {
          languageButton.addEventListener('click', () => {
            const url = languageButton.dataset.manualUrl;
            if (!url) return;

            languageButtons.forEach((item) => {
              item.setAttribute('aria-pressed', String(item === languageButton));
            });

            const model = row.dataset.model || '';
            const language = languageButton.dataset.language || '';
            const label = download.dataset.downloadLabel || 'Download Manual';

            download.href = url;
            download.target = '_blank';
            download.rel = 'noopener';
            download.setAttribute('download', '');
            download.removeAttribute('aria-disabled');
            download.removeAttribute('tabindex');
            download.setAttribute('aria-label', `${label}: ${model} (${language})`);

            const labelElement = download.querySelector('span');
            if (labelElement) labelElement.textContent = label;
          });
        });
      });
    };

    window.NetumManualLibrary = window.NetumManualLibrary || {};
    window.NetumManualLibrary.initialize = initialize;

    document.querySelectorAll('[data-manual-library]').forEach(initialize);

    if (!window.NetumManualLibrary.editorListenerBound) {
      document.addEventListener('shopify:section:load', (event) => {
        const loadedSection = event.target.matches?.('[data-manual-library]')
          ? event.target
          : event.target.querySelector?.('[data-manual-library]');
        window.NetumManualLibrary.initialize?.(loadedSection);
      });
      window.NetumManualLibrary.editorListenerBound = true;
    }
  })();

(() => {
    const initialize = (section) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const normalizeModel = (value) =>
        String(value || '')
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[^a-z0-9]/g, '');

      const rows = Array.from(section.querySelectorAll('[data-printer-row]'));
      const categorySelect = section.querySelector('[data-printer-category]');
      const searchInput = section.querySelector('[data-printer-search]');
      const clearButton = section.querySelector('[data-printer-clear]');
      const noResults = section.querySelector('[data-printer-no-results]');

      rows.forEach((row) => {
        const documents = Array.from(row.querySelectorAll('[data-printer-document]')).map((item) => ({
          name: item.dataset.name || '',
          languageCode: item.dataset.languageCode || '',
          languageLabel: item.dataset.languageLabel || '',
          url: item.dataset.url || '',
        }));
        const manualOptions = row.querySelector('[data-printer-manual-options]');
        const languageOptions = row.querySelector('[data-printer-language-options]');
        const download = row.querySelector('[data-printer-download]');

        if (!manualOptions || !languageOptions || !download) return;

        const manualNames = [...new Set(documents.map((document) => document.name))];
        let selectedManual = manualNames[0] || '';
        let selectedLanguage = '';

        const createOptionButton = (label, value, selected, onClick) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'printer-manuals-library__option';
          button.textContent = label;
          button.dataset.value = value;
          button.setAttribute('aria-pressed', String(selected));
          button.addEventListener('click', onClick);
          return button;
        };

        const updateDownload = () => {
          const selected = documents.find(
            (document) =>
              document.name === selectedManual && document.languageCode === selectedLanguage
          );
          if (!selected?.url) {
            download.removeAttribute('href');
            download.setAttribute('aria-disabled', 'true');
            download.setAttribute('tabindex', '-1');
            return;
          }
          download.href = selected.url;
          download.target = '_blank';
          download.rel = 'noopener';
          download.removeAttribute('aria-disabled');
          download.removeAttribute('tabindex');
          download.setAttribute(
            'aria-label',
            `${download.dataset.downloadLabel}: ${row.dataset.model}, ${selected.name}, ${selected.languageLabel}`
          );
        };

        const renderLanguages = () => {
          const variants = documents.filter((document) => document.name === selectedManual);
          const seen = new Set();
          const languages = variants
            .filter((variant) => {
              const key = `${variant.languageCode}|${variant.languageLabel}`;
              if (seen.has(key)) return false;
              seen.add(key);
              return true;
            });

          if (!languages.some((language) => language.languageCode === selectedLanguage)) {
            selectedLanguage = languages[0]?.languageCode || '';
          }

          languageOptions.replaceChildren(
            ...languages.map((language) =>
              createOptionButton(
                language.languageLabel,
                language.languageCode,
                language.languageCode === selectedLanguage,
                () => {
                  selectedLanguage = language.languageCode;
                  languageOptions.querySelectorAll('button').forEach((button) => {
                    button.setAttribute('aria-pressed', String(button.dataset.value === selectedLanguage));
                  });
                  updateDownload();
                }
              )
            )
          );
          updateDownload();
        };

        manualOptions.replaceChildren(
          ...manualNames.map((name) =>
            createOptionButton(name, name, name === selectedManual, () => {
              selectedManual = name;
              selectedLanguage = '';
              manualOptions.querySelectorAll('button').forEach((button) => {
                button.setAttribute('aria-pressed', String(button.dataset.value === selectedManual));
              });
              renderLanguages();
            })
          )
        );
        renderLanguages();
      });

      const applyFilters = () => {
        const category = categorySelect?.value || 'all';
        const query = normalizeModel(searchInput?.value);
        let visibleCount = 0;

        rows.forEach((row) => {
          const categoryMatches = category === 'all' || row.dataset.category === category;
          const modelMatches = !query || normalizeModel(row.dataset.model).includes(query);
          const visible = categoryMatches && modelMatches;
          row.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (clearButton) clearButton.hidden = !query;
        if (noResults) noResults.hidden = visibleCount > 0;
      };

      categorySelect?.addEventListener('change', applyFilters);
      searchInput?.addEventListener('input', applyFilters);
      clearButton?.addEventListener('click', () => {
        if (!searchInput) return;
        searchInput.value = '';
        searchInput.focus();
        applyFilters();
      });
      applyFilters();
    };

    window.NetumPrinterManualsLibrary = window.NetumPrinterManualsLibrary || {};
    window.NetumPrinterManualsLibrary.initialize = initialize;

    document.querySelectorAll('[data-printer-manuals-library]').forEach(initialize);

    if (!window.NetumPrinterManualsLibrary.editorListenerBound) {
      document.addEventListener('shopify:section:load', (event) => {
        const loadedSection = event.target.matches?.('[data-printer-manuals-library]')
          ? event.target
          : event.target.querySelector?.('[data-printer-manuals-library]');
        window.NetumPrinterManualsLibrary.initialize?.(loadedSection);
      });
      window.NetumPrinterManualsLibrary.editorListenerBound = true;
    }
  })();
}
